module.exports = __webpack_public_path__ + "img/1440.261ec61b.jpg";